





















import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';

@Component
export default class CheckoutUnit extends Vue {
  slider: HTMLElement = null;

  // the current units
  currentUnits: number = undefined;

  // the preselected unit amount
  @Prop({ type: Number }) readonly selectedUnits!: number;

  mounted() {
    this.slider = document.getElementById('input-units');

    jQuery(document).on('change', this.slider, (e: Event) => {
      const jqueryUiSliderValue = Number($(this.slider).val());

      if (this.currentUnits !== jqueryUiSliderValue) {
        this.currentUnits = jqueryUiSliderValue;
        this.$emit('units-change', jqueryUiSliderValue);
      }
    });
  }
}
